<template>
  <div class="form-group" @keydown.enter.prevent.self>
    <label v-if="label" :for="name">{{ label }}</label><span class="text-danger" v-if="required"> *</span>
    <v-select
      :options="_options"
      :id="name"
      :name="name"
      v-model="vModel"
      :label="labelField"
      :multiple="multiple"
      :disabled="disabled"
      :placeholder="placeholder"
      :dir="Lang.getLocale()"
      @input="onChange"
      @search="onSearch"
      :reduce="reduce"
      ref="select"
    />
    <small
      class="form-text text-danger"
      v-if="errors && errors[error_name || name]"
      v-text="errors[error_name || name][0]"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    name: { type: String, required: true },
    error_name: String,
    model: { type: [Object, Array], required: true },
    errors: { type: [Object, Array] },
    options: { type: Array, required: true, default: () => [] },
    labelField: { type: String, required: true },
    valueField: String,
    multiple: { type: Boolean, default: false },
    disabled: Boolean,
    required: Boolean,
    reduce: { type: Function, default: (value) => value },
    selectAllOption: { type: Boolean, default: true },
    meta: {
      type: Object,
      default: () => ({
        current_page: 1,
        last_page: 1,
      }),
    },
  },

  data() {
    return {
      observer: null,
      page: 1,
      lastScrollTop: 0,  // To track scroll position
    };
  },

  computed: {
    placeholder() {
      return `${this.Lang.get("messages.select")} ${this.label || this.Lang.get("messages.option")}`;
    },

    _options() {
      if (this.multiple && !_.isEmpty(this.options) && this.selectAllOption) {
        if (!this.haveAllOption()) {
          this.options.unshift({ id: -1, [`${this.labelField}`]: this.Lang.get("messages.select_all") });
        }
      }
      return this.options;
    },

    vModel: {
      get() {
        return _.get(this.model, this.name);
      },
      set(newValue) {
        if (Array.isArray(newValue)) {
          const allOption = newValue.find((option) => option.id == -1);
          if (allOption) {
            this.options.shift();
            newValue = this.options;
          }
        }
        _.set(this.model, this.name, newValue);
      },
    },
  },

  mounted() {
    this.observeDropdown();
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  methods: {
    observeDropdown() {
      this.observer = new MutationObserver(() => {
        // Attach scroll to only the dropdown of this instance
        const dropdown = this.$refs.select.$el.querySelector(".vs__dropdown-menu");
        if (dropdown) {
          dropdown.removeEventListener("scroll", this.onScroll);  // Prevent duplicate listeners
          dropdown.addEventListener("scroll", this.onScroll);
          dropdown.scrollTop = this.lastScrollTop;  // Restore scroll position
        }
      });

      this.observer.observe(this.$refs.select.$el, {
        childList: true,
        subtree: true,
      });
    },

    reset() {
      this.$refs.select.clearSelection();
    },

    onChange(value) {
      this.$emit("change", value);
      this.$emit("keyup");
    },

    onSearch(value, loading) {
      if (value.length < 2) return;
      this.$emit("search", value, loading);
      this.$emit("keyup");
    },

    onScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      this.lastScrollTop = scrollTop;  // Store current scroll position

      if (scrollTop + clientHeight >= scrollHeight - 50 && this.page < this.meta.last_page) {
        this.page += 1;
        this.$emit("loadMore", this.page);
      }
    },

    haveAllOption() {
      return this.options.some((item) => item.id === -1);
    },
  },
};
</script>
